import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    constructor() {
        super()
        this.state = {
            showVideo: false,
        };
    }

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    playVideo() {
        this.setState({
            showVideo: true,
        });
    }

    render() {
        return <section>
            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/xbow/20161103-JK5_6694.jpg)"}}>
                <div className="scroll-down-wrapper">
                    <div className="scroll-down">
                        <p>Scroll<br/>down</p>
                        <img src="public/images/scroll.svg" alt=""/>
                    </div>
                </div>
            </div>


            <div className="section-wrapper container">
                <div className="row">
                    <div className="gr-7 relative">
                        <div className="image animate"
                             data-transform-y="3vw"
                             data-transform-duration="100%"
                             style={{
                                 transform: "translate(0vw, -3vw) scale(1.2)",
                                 position: "absolute",
                                 zIndex: 0,
                                 transformOrigin: "100% 50%"
                             }}>
                            <img src="public/images/xbow/20140210-JMK_0107-Edit.jpg" alt=""
                                 className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-5 animate"
                         data-transform-y="-5vw"
                         data-transform-duration="150%">
                        <div className="padding-dynamic-left-3 padding-dynamic-bottom-3">
                            <h1>XBOW</h1>
                            <div >
                                <p >
                                    Die seit 2012 bestehende Zusammenarbeit zwischen KTM und Joel Kernasenko konnte
                                    bereits eine große Bandbreite an gemeinsamen Projekten hervorbringen. Dabei arbeiten
                                    Sie gemeinsam an aussagekräftigen visuellen Konzepten, die die Marke sichtbar und
                                    unverwechselbar machen, Emotionen wecken und das Produkt erlebbar machen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="gr-12">
                        <div className="row">
                            <div className="gr-6 animate"
                                 data-transform-offset="-500%"
                                 data-transform-x="-50vw"
                                 data-transform-duration="100%"
                                 style={{
                                     transform: "translate(0vw, -4vw)",
                                     position: "relative",
                                     zIndex: 2
                                 }}>
                                <div className="image">
                                    <img src="public/images/xbow/Capture0003-2-Edit.png" alt="" className="image-resp"/>
                                </div>
                            </div>
                            <div className="gr-6">
                                <div className="image"
                                     data-transform-x="-30%"
                                     data-transform-y="-20%"
                                     data-transform-duration="100%"
                                     style={{
                                         transform: "translate(0vw, -2vw)",
                                         position: "relative",
                                         zIndex: 1
                                     }}>
                                    <img src="public/images/xbow/20140210-JMK_0129-Edit.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="gr-12">
                    <div className="image">
                        <img src="public/images/xbow/grid1.jpg" alt="" className="image-resp" style={{width: "100%"}}/>
                    </div>
                </div>
            </div>


            <div className="clearfix"></div>
            <div style={{marginTop: "150px", marginBottom: "150px"}}>
                <div className="row">

                    <div className="gr-6">
                        <div className="image transform-l-0 animate" data-transform-x="17%" data-transform-y="50px"
                             data-transform-offset="0" data-transform-duration="150%">
                            <img src="public/images/xbow/X-Bow-R-RR-p3_rear45_FLAT.png" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-6">
                        <div className="image transform-r-0 animate" data-transform-x="-17%" data-transform-y="50px"
                             data-transform-offset="0" data-transform-duration="150%">
                            <img src="public/images/xbow/X-Bow-R-RR-p1-1_front45_FLAT.png" alt=""
                                 className="image-resp"/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/xbow/20151211-JMK_7584-Edit.jpg)"}}></div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/xbow/20151019-JK4_0267.jpg)"}}></div>

            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/xbow/20161104-JK2_6483-Edit.jpg)"}}></div>


            <div className="padding-dynamic-4">
                <div className="row row-align-middle">
                    <div className="gr-8">
                        {this.state.showVideo ?
                            <div className="video-wrapper">
                                <iframe
                                    src="https://player.vimeo.com/video/210486602?autoplay=1&color=ff9933&title=0&byline=0&portrait=0"
                                    width="640" height="360" frameBorder="0" webkitallowfullscreen mozallowfullscreen
                                    allowfullscreen></iframe>
                            </div>
                            :
                            <div className="video-thumb" onClick={this.playVideo.bind(this)}>
                                <img src="public/images/xbow/thumbnail.jpg" className="image-resp"/>
                            </div>
                        }
                    </div>
                    <div className="gr-4">
                        <div style={{paddingLeft: "40px", paddingTop: "40px"}}>
                            <div className="text-center">
                                <a href="#/about">
                                    <img src="public/images/joelXguggi.svg" alt="" style={{width: "50%"}}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/xbow/20161104-JK5_9320.jpg)"}}></div>


            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/xbow/20151020-JMK_3014.jpg)"}}></div>

            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/xbow/20161103-JK5_3254.jpg)"}}></div>

            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/categories/boldideas">
                            <h1>NEXT</h1>
                        </a>
                    </div>
                </div>
            </div>

        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/xbow.jsx